/* eslint-disable no-underscore-dangle */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { format } from 'date-fns'
import { translate } from '~/utils/locale'

function AlternativeTaskPDF(
  task,
  reports,
  contributorInfo,
  clientInfo,
  formsInfo,
) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs

  const filteredFormInfo = formsInfo.find(
    (form) => form.id === 'da7bf367-a8bf-4271-bd43-46801b0e5593',
  )

  const ClientName = filteredFormInfo.questions.find(
    (question) => question.id === '3b66860c-edf2-49cd-8abf-a6fddb57fccd',
  )
  const TypeOfService = filteredFormInfo.questions.find(
    (question) => question.id === '117a98f6-91e7-4bf8-a66d-65d827ac53a6',
  )
  const ModalityOfService = filteredFormInfo.questions.find(
    (question) => question.id === '0ab91f2f-08a2-4b50-b165-1883ace879b0',
  )
  const EquipmentOfService = filteredFormInfo.questions.find(
    (question) => question.id === '1626a09f-ea1a-447a-834b-8c9f5d9da82c',
  )
  const ModelOfService = filteredFormInfo.questions.find(
    (question) => question.id === '9e7b291e-1556-4d4b-850c-10d23655b72d',
  )
  const SerialNumberOfService = filteredFormInfo.questions.find(
    (question) => question.id === 'e27aab18-fd47-4ad1-845d-97f7045e458a',
  )
  const ClientProblemOfService = filteredFormInfo.questions.find(
    (question) => question.id === '9d87af21-9fa6-4d3c-ba81-a7213f095e38',
  )
  const ContributorProblemOfService = filteredFormInfo.questions.find(
    (question) => question.id === 'c664c0e0-e9d6-45c3-a7f5-c52b5b1ba855',
  )
  const ContributorSolutionOfService = filteredFormInfo.questions.find(
    (question) => question.id === '59a74bbc-97bf-409b-ad85-e533d65c765d',
  )
  const AftermathOfService = filteredFormInfo.questions.find(
    (question) => question.id === '04ce6154-a261-4170-ba8a-04e62500d348',
  )
  const ObservationsOfService = filteredFormInfo.questions.find(
    (question) => question.id === '855be4d9-51fc-4107-8a3b-8e1b31c45b0b',
  )
  const TaskCallNumber = filteredFormInfo.questions.find(
    (question) => question.id === '7e261f00-cd9f-4d41-8661-a2b983e6e076',
  )
  const ClientContact = filteredFormInfo.questions.find(
    (question) => question.id === 'e26edae8-a8fe-4313-a940-cec7b8ff10ab',
  )

  const reportHeader = {
    columns: [
      {
        text: 'RAT_Gstor',
        alignment: 'left',
        fontSize: 9,
        margin: [20, 10, 0, 0],
      },
      {
        text: translate('TasksPrintPDF.headerTitle'),
        alignment: 'right',
        fontSize: 9,
        margin: [0, 10, 20, 0],
      },
    ],
  }

  function reportFooter(currentPage, pageCount) {
    return {
      columns: [
        {
          text: new Date().toLocaleString(),
          alignment: 'left',
          fontSize: 9,
          margin: [20, 10, 0, 0],
        },
        {
          text: translate('TasksPrintPDF.footerTitle'),
          alignment: 'center',
          fontSize: 9,
          margin: [20, 10, 20, 0],
        },
        {
          text: `${translate(
            'TasksPrintPDF.footerPageOne',
          )} ${currentPage} ${translate(
            'TasksPrintPDF.footerPageTwo',
          )} ${pageCount}`,
          alignment: 'right',
          fontSize: 9,
          margin: [0, 10, 20, 0],
        },
      ],
    }
  }

  const relatosData = reports.map((report) => {
    if (report?.type === 'notes') {
      return [
        {
          text: `TIPO: ${translate('TasksPrintPDF.noteText')}`,
          noWrap: false,
          margin: [0, 2, 0, 2],
        },
        {
          text: report?.title || 'n/a',
          noWrap: false,
          margin: [0, 2, 0, 2],
        },
        {
          text: report?.value,
          noWrap: false,
          margin: [0, 2, 0, 2],
        },
      ]
    }
    if (report?.type === 'image') {
      return [
        {
          text: `TIPO: ${translate('TasksPrintPDF.archiveText')}`,
          noWrap: false,
          margin: [0, 2, 0, 2],
        },
        {
          text: report?.title || 'n/a',
          noWrap: false,
          margin: [0, 2, 0, 2],
        },
        {
          ...(report?.value
            ? { image: report?.value }
            : { text: 'Falha ao carregar a imagem' }),
          width: 150,
          margin: [0, 2, 0, 2],
        },
      ]
    }
    return [
      {
        text: `TIPO: ${translate('TasksPrintPDF.archiveText')}`,
        noWrap: false,
        margin: [0, 2, 0, 2],
      },
      {
        text: report?.title || 'n/a',
        noWrap: false,
        margin: [0, 2, 0, 2],
      },
      {
        text: report?.value,
        noWrap: false,
        margin: [0, 2, 0, 2],
      },
    ]
  })

  const content = [
    {
      table: {
        headerRows: 1,
        widths: [150, '*'],
        body: [
          [
            {
              image:
                'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAN4AAABGCAYAAACjUiqZAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAABqESURBVHhe7V13fFQ3tn7/hJK62bS3u9lkXxqkQXpgN5uEHgiEEEhCCS2MbUILmE7opptquumY3ntLKMYYg03v2GAwpoMB0/t55ztXd+odz4wNHpbVx0+/8Yx0daUjfdLR0ZH4H9LQ0Mh1aOJpaAQBmngaGkGAJp6GRhCgiaehEQRo4mloBAGaeBoaQYAmnoZGEKCJp6ERBGjiaWgEAZp4GhpBgCaehkYQoImnoREEaOJpaAQBmngaGkGAJp6GRhCgiaehEQRo4mk8cMiIj6NNVSrSuncL0Prin1F6zHi6e+uWin04oImn8UAhc+c2Siz9Ja1n0q155w2KffcNiue/j4wfp1I8HNDE03igcHTSBNpYqKCQzgxxTL5NlSuoFLmHg8dO0zetB9J37aLox45DKWHXARWTc2jiaTxQODJimAfx1jLxEsoUo7u3b6tUuYPNyWmUp1QDylMijB4r3YBmrkpUMTmHJp7GA4XTy5ZQnCKbSTyonbubNlIpcg+b9x+mPMVDKc+X9ejxUmE0J3aTivGNU+cz6dzFK+qbJzTxNB4o3Lp0iQ7270PrP3yXEphwCJurVaFr6ekqRe4hu8SbvWYTrd+ZQssSdtLO1KPqV1do4mk8cLhz7RpdTkmms6tXUub2rXQzI0PF5C6yQ7yjpzNo4IwV1HvSIhqzKJY6Rc9RMa4ImHiXr16njMzLdPr8RTqTeUmm08zLV1VsznD7zh3JD+H0hYv2v2/dY93+2o2bUoezXP6Mi5fl71u376jYBw+o//lLVx1l5s/My9dUbPBx6eo1aaezKN8Fo09cvX5TxQYPV6/fkLJAXmdUua7f9H9bYvehY3biPcHEWxS/TcV4x6rNe2hxwjZqPCCG5sdtpn7TlqkYV/hNvKS9qRQxfh7VjBhJ5VsPpDLhfSVU4L+r/DaY+kxeTGu37csWSSCU6Hmr6NeBk6h8qwH0TZtBVDo8Uj6Rf/MhUylmWTydzLignsgacTuSqfuEBdRjwkKa9scG9StR6vEz1CtmEf3UNZoqcN7lWvSnr1sOkPpAUNNXbqRLVzw79IGjp6jvlKXUc+JC6sFhftxWFRM4dh1Ml7KhHCjfiqRdKsYT57mjTFmRQA36TaCKbaNEFmWb92MZDaTK7YdQ62EzaGnCdhmwfAGdcOyitfLurmPnUdz2ZBXDM8ydu5ScfpKiZq6gLmPnUuvh06nzmLk84h9SKTxx5+5dWsd5oB7VOg+XtirXsr/IFG1Yi/tJLx71t6UcUU8YOHLqnMgQz0VOXsIzxDkVY+DOTR4U4+Po8KjhdGjkUDo8YgidnDeHbl7wbPuNuw9S13HzpE4j560WYgF4x7A5K+nnnqOlLCjTVyw3lLFO92ieidZKn3MH5I02NsvWhPtjnmIhQrz8xUO4TtHyO+KdQ7fx82nyivWSx41bt2jEnFU0gsszbvFaGjl/tfzuDp/Eg0m1bo/R9H8/tKQ8JeobI4CEMBXM76H014q/UnVuhMMnzqinswZmmQE8InxUrxM9XtqwHkle8snB6fujJULpQ06HivjqaB1GzaU8pRpSnpK/UKlmkTzK3ZTGfrNGW9e8zfzVOx4vGcoNFElbWMVwBurzXPlfJT+E9+p0pBsBjJwm7nJnLdkk0sinxC/0VLkmFL/TQQAT12/ckoGmaFgXeqos18OUu73Mqtz8+wss8wrcuTbsztrUDQ3l49BuhlxKN6YIJj2A9q3XcwwVqNaa8kn+/C71noEzrEdrDETowH+v1EyVRZXHIrz6YysK7T1O3gOA8HlKoq3r02NlGgp5nXEpeT8llCtJSYUK0sZCBSiRQ/zHheh8kqdFcQCrdKgLLI9v1+5IyUdOiHr3Xu32TBibvR6GzMwyhdETZRrQx7bOtI4HaGdgYDbaBjJQMmfS2UMx/m7GOQeW6ZdNeqtcSLQS1Hc/l+fKtRvqV1d4JR73ERq3JI5er9rKKIAwnyujBP1oiRB6jMmQ16wYKoo0nPYfVVrwCJCgcrLGzoNHqViTXpSXRxIjf/U8VyQff4dOnVd9d7w7lB5lcpRt3peOnT2vcvJEFx7RDaHZqEhoF6rII539PWb5OZ/HOBjfkRbCRWOFUoHqbWhrcprKzUCLIdNUOepJ3Rev9612uCOeF9xPlOT64F1cnupdhqsYB1KPn6bv2w9WaSAXVW4u12MlQ2RwyCudSslFxT/9VX3qP22JysUTUAM/Cemi8qpP3ScuoAU8c79cOdyRjwTEG206aNZy9bQDK1mVKlCtjaNs0iH5U57hMqn8jT7Bvyu5v1e3I63euo8Sdh20Pwf5J+x0HTAu7thO8f/+lOLMDXQOcR8VomtproMhMHD6cuNdLI9Xf2xJ37Hm9XhpVQYpB9o5TLUzApcJbaxki4liNdfHBMiSB+2j6i/PIK0ZUBczzjkw8Z2J5w8siYeRucfE+UpAqqD895Olf5Fpu2G/iTKVjlm4lppFTRZV89nyPPKYBeW0fy7XSKZ/K2xNPsyzTzuX9I8Uq0cf/NyRbL3GiAo2bnEcd46FMtsWxgiGtOhwKA+n/2f9brTjgKsaY8JBPAjsZ0mPZx/h70XDIlh1m0iDWK0aweot/v6sQXdjtHeqK2bhTCe1c/O+w/RUGR4N1fsrseoXKOp0H2WUhd8B1cWd3LtTj9JHLANpYFUOjM4lfu1NjfvH0OiFsTRh6TrqO3WJqPyv82xiyARpbdzBwph81rOUC/E43y8b9aC/VWyqnufA9X++QhN6n2fzqp2GUe1uo+gPNzV4ReJOHohb8zNmu/FznN9rXA6UBzPnL5ETpA2hfkLDyIvOjjpzeOm7cCm7KWdL4u1k4n1R1JV4n7xP10+eUCkcsBMPZbEHzpvf9T4T/WfuOwOmr6DoBWuoxdCpIsf8PIA5tzPKvjv1mOSHpQzaFRvmVXjwK/FrH6OOnDZfcRv3uQj5HfHOARpH++hZkoe/sCTeqIVr6DGecYwCGhX5mvX3JbyeOHfxskrlAPTalZt307dtB0lao1I2euqrBrRm616VygDUtsJ1OziIwY1YkBsIJIAKYwVM2QOmL6P//YbVPTN/fh6CtJr5XIlnlAWzc6+YxXTsjOuaAjh65jz1nrSYR0eVN4d83PmjZv6uUrD6x6qlrddYe8f9G6tZsTyC+4s9vFAvyDOplJ/z+JYb2NkoBYMPBjV7p+b3F6jemiYtX28pc6jbO3m9WLdbNM+AjnpicIAp2x0uxFNpjc8Q+guP/O1GzuTRfy+raydlzeeOLTxIvMHqqPOg8Bduj4hx8z0GEODmrdui1USxOvjqDxgg+Dku54vfsXqK5zlYES9zxzaK/7xIjojXdsRMy750htXtaB68nvqKB1Cn+odHTVEpjHIjABv38Oys5AUNbMaqjfK7mcY5BGrb8CBe4t5U0ctFUFIwGy+2Z9L5S943A03A0tZh9BxDFeJQJLQzHT7pWO+hQet0H+1ofP58r04HSuQK+oOtKWlUrFFPztvxPNYPqLgzXIjH5YBq6G0mcAYsUPbRkJ8v1thVfVixcSc9BVUG9eMZoplTg/lCJ5aL0flsMnpOdTL6AC2GTDHiVZkLcifHDOgLV65dF61DnpNyh4ixyN1K60E8eU+I/Ba3fT/d5X/egPUsDCf2Z/kdRfg5EN8fw87W5COioRj1V3XkYEW8q0fSKKnyN+KfaRJvHYh34rhK4YAV8WAUgsaWFWBcEfUTbc11wuyIwd0dGFDMOoN4c9duVjE5hwvxwNqG/SdKp5KK8Evr9x0vM5q/ALnaDJ9BIX3GeZi8MUPkNxuPOxdGQqvRMitgQ/JVGHrQ+SG4z+tR0h5X65sL8fizZkS0iskaJ89lioppEuSFb5rQMiabCcxKlVmtFvlwmn9UbuFhiLHCIZ7lP2UVV8rE4QtW8447zdTYL3pNVDijY2Lg28Gd2l/AYlmpHZdLlRuawcqk3SrWgCfxbFz+cNrlB7nnrd1Cf2LtxRiUbLIuTEn37KhZYfuBNDHgSBnl/dbEu8tE3tOmhd1tbC2H+M8+5RnvpErhgAvxuF7FeZ11/Kxvy/dlHqxgFTbWfMaz8yxIlRPPFV9wIR7UoWe/biSNhxe+X7cTHTrun4XSGagYpnV3fPdblEPw/Dn1d9dR31/AEmp0AuRjo69b9FMxBpyNKzBGxCyNVzG+0XPiIuNZzvfPZRvQnDWuwp60PJ7VOTXrcTqsdX1h/JJ19vLk59kuys1o0XrYdHs86gSzfqCYE7tZPc+BZdt8sOtsbKVqouP6g6odhzme49Bvqm/twQqRU5dSPshN5WNFPGBfh7Z24kHl3PR9JbplsZ3gTryICQtUjG+g3WApN9oxhIbO+UPFOJBrxOs9mRe+6kVQF7HuuVfATPXKj45RHaqKP+qrFfDcKz+04HKik9nopSrNeZ3mWLvZicdxL/Ja7Bx3On8BYpnPYtMUZn1nQIUrEsqzl6rHP8O60YUs6oF13Ef1OtvTF67T3qXe2E8qywOHvJM7AAxJ+9I81SpfwMxVsHpb4z08I1frNNxF5XI1rthkfXbQy5raGemnMugTm/kcjE6dKe3kWRUbGE5mZDppK1kQr2M7O/ESChWg/V06Wp7HsxOP83uufGNatH67ivGNuUyiZ8o1NMrCdYOm575kyTXiwaIjBUFFeObb7rb5mRNgdvsTrILInztGz5hFKiZ7aD9qthKKQZAJPKuYcCYetjYCgTPxIHCrkXDGqkRjHcvx6IwL1nnfUJ8bt4XTGCM88uw92XUww1ETw6hjdICy4ZGieew5fFw8J/wJezktOokYZ1B2P4iHbSKQyhfgkQ+twWw3ODPkBOUwyCjZ+Uu8g317iwrqDgfxQmSLwx+12QT8KaHRSFlYJqF9eEnltjeba8TLXwIdwOggf/8uXP16byAGAKyNkD8Lax53yJxgMY9uhpHFJurLgGkOtcmZeC9Xbm5ppfMGf4gHK+PrmL3VjFvczQjjjPIwSkheRlnOXHBVwVck7jJkogK2GdDR0dCBBhhtDPn6IB6H0s0ixZXKF6b9sdGhknEd/FGts0IYd3BTtv6omkK8yF7+Ee/gfyjxzMZHYWA6vpdoOgjEgz5uo7z8juXc4XICuIWZQoHg4W5m4n4TD+iOtSCIz+meLtuQlm9wGGFMJO49SC9UaGzkxQt5qPLugJOC+S5n+ecolKwv+2hZEa9SuyjKvOLbxxaOEBgMIGMMcKZrVHYxhOWJvFBPb8RL6dndfgL9v4R4XAjV8AVr3Cficd4Q+B9uVrdA4UI87hiNB8aomNwhHtS7l1krkHRMwBrc0d1h6zlG5WVs1Fqt3UYtWGN/FwL24Z7n9QpU/ewGyBeb2VkRD3uuzg4C3oAlArZjhHg8o07KIfHgV+mLeMemTqbYwm+KRVOIN6Cv4UrlhoeGePdT1WwqqiZmPBAlTNyVcgI4FxtC4RmU11B9nAxBuUE8oM3wmVIXNDw8cbY7edJgm0Fcq9DJOD/sL1kBHu/GgGe8D540eBZrv+wGuKalpLsaTnJCPLFESgjxWKMGikqt4WRh1NUb8U7Om01rP3hHDsOu43Bk/BgV44qHhng4bWAI2EbPs4qU4ofVy19ApZJFOjoYr0EGz/beof1BnylLuJxGfhAKnGNN5Bbx4nekSP5CLg44wWCiG0Z2yQezXWs53WEFkMQwvhgdAC5X9wPZJR4cieHqJXXkQaZ291Gyn5kdYD+4qGykG7L1RrwTc2dR7Ptvy1YCNtBPL7X2QX1oiNdl7Hz7i6DXD80hOZyxZX8avVylhdGAHMrw4v6iHw1vhSvXb9A7tWA6Z6FxeJE7BjzLTeQW8YCqnYYa6Tl8bOtCp85liltaweqOrZNa3bxv4MM0XySsqz2PovUj6Aj/dq+RXeJdvnZDXPPkOZYJHIu3Bej0YGJ78hFRhU3Z+kM8rPMy1qxSMa7IbeLdN8+VLfsPyQavOfr+u0HWe1TegGMtVqQq1RROp9wZuSJ4x9IN/u+7OGM8z54OE30IlWjqalXMTeJhxnqmnOpMXJbZqzcZ5YNBguv49FcNxKM/K8i5L7H42kTdhzP0vUZ2iQdEjGN5ok+IvEOpUf8Yj07qCzjnWL3TcLtcEbwSb94cimVV0yQeTqJbITeJh7LOWp2kYnIOF+JBhajbHQYBtRbj0GHUbL/88ZyBmRJWxguXXUm7fONO5R2OBrTJmSg45QaC/Zy+gGwUqwb8op44bzsjN4kHwDtd0qNO9TobM5j6XsptULDCyk17ZCYxngmhd2u1t/Qd9IXk9BNMMM8DnkBOiHf87DlWlx0b3xj0cAAV5xz9AZwO4Ksq2x1mHhy8Ee/s6lW0ruhHvL4zVM3gEk9tgfHA02bYDBWTc7gQD4CH+l8rNpPKoFDw0XNeu/gCTnE/V74JEyxMztuln3Rs0sIXtPJv8JEzyRdKJVmNSVWHJH0BJxu+weL8SzVrcj6V2w32WHPkNvEWrYeBxOhMRr0cnWt5ouc2gxXq4siQzJJ4PkT2Bo/6scFtYuOug3JspX7keA8HaSAnxAOiZv3OZUO9jIC9vZZDp1menHAGroIIj5pKz+BAr8jFIRtvxMPFRhvLlZIthdj33qKMOGsN4H4TDxvyT8IpHmXmNFge3St4EA9oN2KWUyeA+hNKIb3HyVELd7caAGZrHOFvOiiGdWF0WpDWIO7abftVKgOozIuV1GId+XOFPg3tKrOht30lqLtzYpOUuxGeMwQB96WUdM8ZM7eJBxewT9GpzTqpeuEolb/rWLiO2V3LRO4h9PZP7WjsojjWHKzlgoHsxNkLcqQKLlPyLIdGfR1bKyZySjwMbjW7jjSeV+TDgeW3arQRDWfjrgNy0Q/OtOETxqSeMQupIMeLLFW9ngUBlYy8Ee/O9etyQgGb6BtKfUmX9lhvPd1v4kF7KI4zeagzp4PnFY6KBdKfvMGSeCAX7vlwFjJe/OK3TWU/bvziOPojcRetYhVp8vL11HnsXHHNMoWLtE9yISPGz7dUU3GgEtsVRv5GJ8MhzjLN+ogw4ZIF9Qv3pUROWUKfN+wheUqQ9Dgl3pbWeDkPl9vEA9D57fWXYJPGDQQ4noMO5C6XLxr1lDttZq1JkhPTKzftphiWe8th0+mdmr8Z7zVlw8/W6TbKohPljHhAGmsvVTsOlVPdjrZAu4TQ46zhYGBE+fEp5znNcolcbFS7W7QcTjWf9UW8pMIFaWutanTjtLVGdL+JB6D/GeU36gojS/3ICeJYAO0QHEBAv7E6B+kNlsQDrvMI13LodHqW1UbTUCCBdV74KUJ1eLZcI8OrQSpvCBOFhPc+rhbI6kYn7MN98HMnoyOYeWN7gPNC5eDAik4nRgdz9pU0OOfX1at5HggG8XCK49NQnrFQVn6+ZNM+YuEMFBv2HKRijXuJHO0yFRkb11VA5pBNXuy5QjaqUyMNjDze1L97QTwgg2cBXF33QgXuF/YyGu1iBPymfkfgd73EbYBLgaC5hDudOzSI59lZTeJtYuJtD61Lty5ayzE3iAd/1s+wBQK5SR/kwBogrhJBW5gBZejI61h/4ZV4ADrs70m75boEIQEEphrOM2B0hvpnHKy0qoQ7jp05LzPo8+UbqTtRvOSvGvI5TofK4dxcVug0hoknd2eE0svftwyIeBOXrbM/i/JEzfL/iE5nITwPTPzcIKfT64HiBKtrvXmkxf4ZTsJ7lQsCywZyh8kf1lNvhjD4iH6CUxWoGwfcuOVNhfUFLC3QycMHT6HXeHZ7uuwv9ERp9A+jY2JdhMEBd9d0Za0HhiKzDap3GSFtiXRYllhd0iTEq1LRJ/EGgHjqivU3WAPCiXd/MXNVEj2N0wloZ5ZHCK+NvZ073Xv4GP0L5APpPNoAEwOHkr9wv7tHxDNxhQWxOGG7GDKwlilUq734csINqlDt3+hDnrkqth3InTZe1h2BAI2IC35a8ewKQ0vh2u05z/ayvilcpwN/70DlWw6gDtGzKc3P28tm8WhWjRu4RsRIajJokovrlC9gw/jHTsPoJ362JqtGWV2/5479vN78JKSrqIa41SunwGgLRwHMnjipD7XyFR5IcNcKZITjOt+3HyKHdX0dVsZa87dRs6lq5+EScNr+Xtx9iSNX8LTB1lDH0bOZaPNkCYADzlbrW7sFmGdJLDecDwSbuHv7Fm2pVV1UzayIh3d+z6pvtS7DeSadSuluVwVmBVzrgMPaNXjdCnmMXhSbZd/FfbJD56yUAQ6yx30yWF69yWtY8AEW+tm8FPAXfhHPBEatUxmZolbhyBAEjr+P88x128KSFijQEdJOnBUrJ7YZkDe+B3IJabCBk+M40nMvgYPF6afOiXErcU8qbUtJo8MsFxgyAh3oggkYaD6o29EgHoc3eUa0ssACe1o2o8RCBWlH/Xp0+5L1FkkwgPOV6JPw1YV73t604/L9dIDLioCIp/HfDaz7cWt0dgGXqydKsaoLlY3X87gy0RtSekbQhncL0r62rXL9fwnKDWjiafgFqOu4Zfmdmu3E2oybpAMB1q1YSsh6ndXMR3ndCmugNxzo3V3+wxIcgn0YoYmn4RdwBUY+OR5ko/xMHlhP96b5512DKx8qtBoos5xpoMDaNKv/cyOlVzchXuqgAeqXhwuaeBp+ocMoXE+oiKPI81aNttQuehZt4LUO1v/uRixsa4xdvJb+1aAHPSIzHVTMELkHx9serIlkVjXhuZI6eKD65eGCJp6GX4DfbdsRM2SbQLY31N4hrtnHdtAbVVtT6fA+1HTQJArrM04sri9VDpc9WTG7K7LiRL55MWxWOBw9XO7WTI3SM56Ghuzr4vp38ZcFoZSF0txr9fgum+tIGybbIXD98wdnY1eLg3RqlJ7xNDQE8A8dOX+V/D8CcIg3CAiiWQSeFV//oaWsCfcFcOLiyqFUWlf0Qzki9DBCE08j27h09bpcRQi/xUb9Jsp/ZmOGBn0nUPPBU2nZhh106PhpS+f6rHDt2FHa8FUJurQ3Z3fzPKjQxNPQCAI08TQ0ggBNPA2NIEATT0MjCNDE09AIAjTxNDSCAE08DY0gQBNPQyMI0MTT0AgCNPE0NIIATTwNjSBAE09DI9dB9P+lbw5Lm54lFQAAAABJRU5ErkJggg==',
              width: 150,
              height: 60,
            },
            {
              text: translate('TasksPrintPDF.contentTitle'),
              bold: true,
              noWrap: false,
              fontSize: 20,
              fillColor: '#cfe2f3',
              alignment: 'center',
              margin: [0, 20, 0, 20],
            },
          ],
        ],
      },
    },
    {
      style: 'tableExample',
      table: {
        widths: ['50%', '25%', '25%'],
        body: [
          [
            {
              text: 'NOME DO CLIENTE',
              alignment: 'center',
              fillColor: '#d9d9d9',
              bold: true,
            },
            {
              text: 'NÚMERO DO(S) CHAMADO(S)',
              alignment: 'center',
              fillColor: '#d9d9d9',
              bold: true,
            },
            {
              text: 'DATA DO ATENDIMENTO',
              alignment: 'center',
              fillColor: '#d9d9d9',
              bold: true,
            },
          ],
          [
            { text: ClientName?.answer?.value || 'N/A', alignment: 'center' },
            {
              text: TaskCallNumber?.answer?.value || 'N/A',
              alignment: 'center',
            },
            {
              text: format(
                new Date(task.date),
                `dd/MM/yyyy '${translate(
                  'TasksPrintPDF.dateString',
                )}' HH:mm'h'`,
              ),
              alignment: 'center',
            },
          ],
        ],
      },
    },
    {
      style: 'tableExample',
      table: {
        widths: ['50%', '50%'],
        body: [
          [
            {
              text: 'ENDEREÇO',
              alignment: 'center',
              fillColor: '#d9d9d9',
              bold: true,
            },
            {
              text: 'TIPO DE SERVIÇO',
              alignment: 'center',
              fillColor: '#d9d9d9',
              bold: true,
            },
          ],
          [
            {
              text: `${task?.address?.street}, ${task?.address?.number}, ${task?.address?.neighborhood}, ${task?.address?.city}, ${task?.address?.state}`,
              alignment: 'center',
            },
            {
              text: TypeOfService?.answer?.value || 'N/A',
              alignment: 'center',
            },
          ],
          [
            {
              text: 'CONTATO',
              alignment: 'center',
              fillColor: '#d9d9d9',
              bold: true,
            },
            {
              text: 'MODALIDADE DO SERVIÇO',
              alignment: 'center',
              fillColor: '#d9d9d9',
              bold: true,
            },
          ],
          [
            {
              text: (() => {
                const clientContactValue = ClientContact?.answer?.value

                if (clientContactValue) {
                  return clientContactValue
                }

                const phone = clientInfo?.contact?.phone || 'N/A'
                const email = clientInfo?.contact?.email || 'N/A'

                if (phone === 'N/A' && email === 'N/A') {
                  return 'N/A'
                } else {
                  return `${phone} | ${email}`
                }
              })(),
              alignment: 'center',
            },
            {
              text: ModalityOfService?.answer?.value || 'N/A',
              alignment: 'center',
            },
          ],
        ],
      },
    },
    {
      style: 'tableExample',
      table: {
        widths: ['*', '*', '*'],
        body: [
          [
            {
              text: 'EQUIPAMENTO / SISTEMA',
              alignment: 'center',
              fillColor: '#d9d9d9',
              bold: true,
            },
            {
              text: 'MODELO / NÚMERO DA PEÇA (P/N)',
              alignment: 'center',
              fillColor: '#d9d9d9',
              bold: true,
            },
            {
              text: 'NÚMERO DE SÉRIE (S/N)',
              alignment: 'center',
              fillColor: '#d9d9d9',
              bold: true,
            },
          ],
          [
            {
              text: EquipmentOfService?.answer?.value || 'N/A',
              alignment: 'center',
            },
            {
              text: ModelOfService?.answer?.value || 'N/A',
              alignment: 'center',
            },
            {
              text: SerialNumberOfService?.answer?.value || 'N/A',
              alignment: 'center',
            },
          ],
        ],
      },
    },
    {
      style: 'tableExample',
      table: {
        widths: ['100%'],
        body: [
          [
            {
              text: 'PROBLEMA RELATADO PELO CLIENTE:',
              alignment: 'center',
              fillColor: '#d9d9d9',
              bold: true,
            },
          ],
          [
            {
              text: ClientProblemOfService?.answer?.value || 'N/A',
              alignment: 'center',
            },
          ],
        ],
      },
    },
    {
      style: 'tableExample',
      table: {
        widths: ['100%'],
        body: [
          [
            {
              text: 'PROBLEMA CONSTATADO PELO TÉCNICO:',
              alignment: 'center',
              fillColor: '#d9d9d9',
              bold: true,
            },
          ],
          [
            {
              text: ContributorProblemOfService?.answer?.value || 'N/A',
              alignment: 'center',
            },
          ],
        ],
      },
    },
    {
      style: 'tableExample',
      table: {
        widths: ['100%'],
        body: [
          [
            {
              text: 'SOLUÇÃO ADOTADA PELO TÉCNICO:',
              alignment: 'center',
              fillColor: '#d9d9d9',
              bold: true,
            },
          ],
          [
            {
              text: ContributorSolutionOfService?.answer?.value || 'N/A',
              alignment: 'center',
            },
          ],
        ],
      },
    },
    {
      style: 'tableExample',
      table: {
        widths: ['100%'],
        body: [
          [
            {
              text: 'APÓS O ATENDIMENTO, CLIENTE ESTÁ CIENTE QUE:',
              alignment: 'center',
              fillColor: '#d9d9d9',
              bold: true,
            },
          ],
          [
            {
              text: Array.isArray(AftermathOfService?.answer?.value)
                ? AftermathOfService.answer.value.join(' | ')
                : AftermathOfService?.answer?.value || 'N/A',
              alignment: 'center',
            },
          ],
        ],
      },
    },
    {
      style: 'tableExample',
      table: {
        widths: ['100%'],
        body: [
          [
            {
              text: 'OBSERVAÇÕES:',
              alignment: 'center',
              fillColor: '#d9d9d9',
              bold: true,
            },
          ],
          [
            {
              text: ObservationsOfService?.answer?.value || 'N/A',
              alignment: 'center',
            },
          ],
        ],
      },
    },
    {
      text: 'DADOS DO CLIENTE RESPONSÁVEL TÉCNICO',
      style: 'subheader',
    },
    {
      style: 'tableExample',
      table: {
        widths: ['*', '*'],
        body: [
          [
            { text: 'DADOS DO CLIENTE', fillColor: '#d9d9d9', bold: true },
            {
              text: 'DADOS DO RESPONSÁVEL TÉCNICO',
              fillColor: '#d9d9d9',
              bold: true,
            },
          ],
          [
            `Nome: ${ClientName?.answer?.value || clientInfo?.contact?.name}`,
            `Nome: ${contributorInfo?.contact?.name}`,
          ],
          [
            `Telefone: ${clientInfo?.contact?.phone || 'N/A'}`,
            `Fone: ${contributorInfo?.contact?.phone || 'N/A'}`,
          ],
          [
            `E-mail: ${
              ClientContact?.answer?.value ||
              clientInfo?.contact?.email ||
              'N/A'
            }`,
            `E-mail: ${contributorInfo?.contact?.email || 'N/A'}`,
          ],
        ],
      },
    },
    {
      text: 'ANEXOS',
      style: 'subheader',
    },
    reports.length > 0
      ? {
          style: 'tableExample',
          table: {
            widths: ['auto', 'auto', '*'],
            body: [...relatosData],
          },
        }
      : 'N/A',
  ]

  const docDefinition = {
    pageSize: 'A4',
    pageMargins: [15, 50, 15, 40],
    header: [reportHeader],
    footer: reportFooter,
    content: [content],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        alignment: 'center',
        margin: [0, 10, 0, 10],
      },
      subheader: {
        fontSize: 14,
        bold: true,
        margin: [0, 10, 0, 5],
      },
      tableExample: {
        margin: [0, 5, 0, 5],
      },
      checkbox: {
        alignment: 'left',
        margin: [0, 5, 0, 5],
      },
    },
  }

  pdfMake
    .createPdf(docDefinition)
    .download(`RAT_gstor_${new Date().toLocaleString()}`)
}

export default AlternativeTaskPDF
